import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LegalPage from "./pages/LegalPage";
import AffiliatesPage from "./pages/AffiliatesPage";
import { Toaster } from "./components/ui/sonner";
import LanguageWrapper from "./components/LanguageWrapper";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:lang" element={<LanguageWrapper />}>
            <Route index element={<LandingPage />} />
            <Route path="aviso-legal" element={<LegalPage />} />
            <Route path="politica-privacidad" element={<LegalPage />} />
            <Route path="politica-cookies" element={<LegalPage />} />
            <Route path="condiciones" element={<LegalPage />} />
            <Route path="aliados" element={<AffiliatesPage />} />
          </Route>
          
          <Route path="*" element={<Navigate to={`/${localStorage.getItem("i18n_lang") || "es"}`} replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
